import * as React from 'react'
import CustomBrowserRouter from 'components/CustomBrowserRouter/CustomBrowserRouter'
import DownloadManager from 'apps/Panel/components/DownloadManager/DownloadManager'
import Index from './apps'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import SupportChat from 'components/SupportChat/SupportChat'
import { AppContextProvider } from 'context/appContext'
import { AuthContextProvider } from 'context/authContext'
import { DownloadManagerProvider } from 'shared/context/DownloadManagerContext'
import { FilterContextProvider } from 'context/filterContext'
import { FrontinoProvider } from '@conekta/frontino-ui/v2/providers/FrontinoProvider'
import { I18nProvider } from 'shared/context/I18nContext'
import { LayoutContextProvider } from 'shared/context/LayoutContext'
import { Container as ModalContainer } from './components/Modal'
import { Container as SidePanelContainer } from './components/SidePanel'
import { ToastContainer } from 'react-toastify'
import { UIContextProvider } from 'shared/context/UIContext'
import '../assets/scss/App.scss'

const App = (): React.ReactElement => (
  <AuthContextProvider>
    <AppContextProvider>
      <DownloadManagerProvider>
        <FilterContextProvider>
          <LayoutContextProvider>
            <UIContextProvider>
              <I18nProvider>
                <CustomBrowserRouter>
                  <ScrollToTop>
                    <FrontinoProvider>
                      <AppWrapper>
                        <Index />
                        <SupportChat />
                        <ToastContainer />
                        <DownloadManager />
                      </AppWrapper>
                      <SidePanelContainer />
                      <ModalContainer />
                    </FrontinoProvider>
                  </ScrollToTop>
                </CustomBrowserRouter>
              </I18nProvider>
            </UIContextProvider>
          </LayoutContextProvider>
        </FilterContextProvider>
      </DownloadManagerProvider>
    </AppContextProvider>
  </AuthContextProvider>
)

const AppWrapper = (props: any): React.ReactElement => <div className='App'>{props.children}</div>

export default App
